import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-grid-row-link',
  template: `
    @if (routerLink) {
      <a [routerLink]="routerLink">{{ value }}</a>
    } @else {
      {{ value }}
    }
  `,
  standalone: false,
})
export class GridRowLinkComponent {
  @Input() routerLink?: string[] | null;
  @Input() value: string;
}
